
















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { checkMobile } from '../../utils/utils'
import Notification from '../atoms_molecules/Notification.vue'
import { notificationState } from '../../stores/notification'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'

@Component({
  components: {
    Notification
  }
})
export default class NotificationList extends Vue {
  mobile: boolean = false

  breadcrumbs = [
    {
      text: 'クラスルーム',
      disabled: false,
      exact: true,
      to: '/classroom/'
    },
    {
      text: '通知',
      disabled: false,
      exact: true,
      to: '/classroom/notifications'
    }
  ]

  get notifications(){
    return notificationState.notifications
  }

  created() {
    this.mobile = checkMobile()
    headerState.setTitle('通知')
    footerState.setFooterDefault()
    notificationState.getNotification({ checkNotification: true })
  }
}
